/* unplugin-vue-components disabled */import { render } from "./member_receive_m.vue?vue&type=template&id=1e995a08&scoped=true"
import script from "./member_receive_m.vue?vue&type=script&lang=js"
export * from "./member_receive_m.vue?vue&type=script&lang=js"

import "./member_receive_m.vue?vue&type=style&index=0&id=1e995a08&lang=scss&scoped=true"
import "./member_receive_m.vue?vue&type=style&index=1&id=1e995a08&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e995a08"]])

export default __exports__